export const canPlayInTournament = t => t.playerStatus === 'registered' && 
  (t.tournamentState === 'inProgress' || t.tournamentState === 'lateRegistration');

  export const canRegisterInTournament = t => !['registered', 'finished'].includes(t.playerStatus) && 
  (t.tournamentState === 'registration' || t.tournamentState === 'lateRegistration');

  export const canUnregisterInTournament = t => t.playerStatus === 'registered' &&
  (t.tournamentState === 'registration' || t.tournamentState === 'lateRegistration');

export const sortTournaments = tournaments => {
  const primaryTournaments = tournaments.filter(tour => canRegisterInTournament(tour) || canUnregisterInTournament(tour));
  const secondaryTournaments  = tournaments.filter(tour => primaryTournaments.filter(item => item.tournamentId === tour.tournamentId).length === 0);
  let finallArr = [];
  const tournamentStates = ['lateRegistration', 'announce', 'finished'];
  tournamentStates.forEach(item => {
      finallArr = [...finallArr, ...secondaryTournaments.filter( t => t.tournamentState === item)]
  });
  return [...primaryTournaments, ...finallArr];
}